import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { formatComputedValue } from 'utils/agendaRecord/agendaRecord';
import { CartContainer, CartNameSpan, ContentWrapper, InfoRow } from './CartItem.styles';

export interface CartItemType {
  id: string;
  name: string;
  productCount: string;
  totalPrice: string;
  agendaId: string;
  moduleId: string;
}

interface Props extends CartItemType {
  onClick: (viewId: string, agendaId: string, moduleId: string) => void;
}

export const CartItem = memo(({ id, name, productCount, totalPrice, agendaId, onClick, moduleId }: Props) => {
  const { t, i18n } = useTranslation();

  return (
    <CartContainer onClick={() => onClick(id, agendaId, moduleId)}>
      <ContentWrapper>
        <CartNameSpan>{name}</CartNameSpan>
        <InfoRow>
          <span>
            {productCount} {t('flow.view.items')}
          </span>
          <span>{formatComputedValue(totalPrice, i18n.language)}</span>
        </InfoRow>
      </ContentWrapper>
    </CartContainer>
  );
});
